/** What the sound bank knows about one sound besides its patch: how to mix and prioritise it. */

import type { Patch } from '../synth/patch';

export interface SfxDef {
  patch: Patch;
  /** Seeded variants rendered; the player cycles through them so bursts never sound stamped out. */
  variants: number;
  /** 1 (first to be stolen) .. 5 (never stolen in practice). */
  priority: number;
  /** Mix level, 0..1, applied on top of the peak-normalised buffer. */
  gain: number;
  /** Metres at which it has faded to nothing. Default: `SPATIAL.maxDistance`. */
  maxDistance?: number;
  /** Seconds before the same sound may trigger again (one blast throws ten impacts in a frame). */
  minInterval?: number;
  /** Random playback-rate spread per play, as a fraction. */
  rateSpread?: number;
}

/** Voice priorities, highest kept longest (07 §5: stealing by priority, then distance). */
export const PRIORITY = { ambient: 1, detail: 2, cue: 3, action: 4, critical: 5 } as const;
